export default __webpack_public_path__ + "static/media/HippyEric.42615303.jpeg";